<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="科任统计"
      :expand-all-row="true"
      :page="false"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="getDataFunc"
      :show-reset="false"
      :setTable="true"
      table-title="信息列表"
      :show-result="true"
      :custom-search="customSearch"
      @count="count"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="阶段分化考试名称" :class="isMB?'':'listLabelLong'" :style="isMB?'':'margin-left:5px;'">
          <el-input v-model="names.thisname" class="longInp" size="mini" readonly />
        </el-form-item>
        <el-form-item label="中考分化考试名称" :class="isMB?'':'listLabelLong'">
          <el-input v-model="names.thisname2" class="longInp" size="mini" readonly />
        </el-form-item>
        <el-form-item label="入口考试" v-if="isMB">
          <el-input v-model="names.enames" size="mini" readonly />
        </el-form-item>
        <div class="entryBox" v-else>
          <span class="entryTitle" style="margin-left:29px">入口考试名称</span>
          <el-input class="entrySelect" style="width:calc(100% - 130px);" v-model="names.enames" :title="names.enames" size="mini" readonly />
        </div> 
      </template>
      <template slot="table">
        <el-table-column prop="Subject" label="科目" align="center" />
        <el-table-column prop="TeacherName" label="教师姓名" align="center" />
        <el-table-column label="强势科" align="center">
          <el-table-column prop="StrongCount" label="合计" align="center" />
          <el-table-column prop="StrongCount0" label="阶段分化" align="center" />
          <el-table-column prop="StrongCount1" label="中考分化" align="center" />
        </el-table-column>
        <el-table-column label="弱势科" align="center">
          <el-table-column prop="WeakCount" label="合计" align="center" />
          <el-table-column prop="WeakCount0" label="阶段分化" align="center" />
          <el-table-column prop="WeakCount1" label="中考分化" align="center" />
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { 
    list,
  },
  data() {
    return {
      api: require("@/api/analyse/analyse").default,
      isMB: this.$store.state.isMB,
      params: {
      },
      names: {
        thisname: "",
        thisname2: "",
        enames: "",
      },
      aid: "",
      eaid: "",
      Entries: [],
      data: [],
      customSearch: [
        { bn: "统计", fn: 'count', disabled: false },
      ]
    };
  },
  methods: {
    getDataFunc() {
      return new Promise((resolve, reject) => {
        // if(this.aid||this.eaid) {
        //   resolve({ Data: []})
        // }
        this.reset();
        this.api.getLastAnalyse(0).then(res => {
          if(res.Data.AnalyseId) {
            this.aid = res.Data.AnalyseId;
            this.names.thisname = res.Data.ThisExamCode;
            this.Entries = res.Data.Entries;
            res.Data.Entries.forEach((e,index) => {
              this.names.enames += e.EntryCode;
              if(res.Data.Entries[index+1]) {
                this.names.enames += '，';
              }
            })
            if(this.eaid) {
              let Ids = [this.aid];
              if(this.aid != this.eaid) {
                // this.$message.warning("阶段分化与中考分化的当前考试名称不同");
                // return
                Ids.push(this.eaid);
              }
              this.Entries.forEach(e => {
                Ids.push(e.AnalyseEntryId);
              })
              this.api.getTeacherStat({ Ids }).then(res2 => {
                this.data = res2.Data;
                if(this.aid&&this.eaid) {
                  this.customSearch[0].disabled = false;
                }
                if(res2.Data.length==0) {
                  this.$message.warning("当前考试暂无科任统计数据");
                } else {
                  // this.$emit("can-export",false);
                }
                resolve(res2)
              })
            }
          } else {
            this.$message.warning("请先生成阶段分化数据");
          }
        })
        this.api.getLastAnalyse(1).then(res => {
          if(res.Data.AnalyseId) {
            this.eaid = res.Data.AnalyseId;
            this.names.thisname2 = res.Data.ThisExamCode;
            if(this.aid) {
              let Ids = [this.aid];
              if(this.aid != this.eaid) {
                // this.$message.warning("阶段分化与中考分化的当前考试名称不同");
                // return
                Ids.push(this.eaid);
              }
              this.Entries.forEach(e => {
                Ids.push(e.AnalyseEntryId);
              })
              this.api.getTeacherStat({ Ids }).then(res2 => {
                this.data = res2.Data;
                if(this.aid&&this.eaid) {
                  this.customSearch[0].disabled = false;
                }
                if(res2.Data.length==0) {
                  this.$message.warning("当前考试暂无科任统计数据");
                } else {
                  // this.$emit("can-export",false);
                }
                resolve(res2)
                // resolve({ Data: [
                //   {
                //     TeacherId: 1,
                //     TeacherName: "string",
                //     SubjectId: 2,
                //     Subject: "string",
                //     StrongCount0: 3,
                //     WeakCount0: 4,
                //     StrongCount1: 5,
                //     WeakCount1: 6,
                //     StrongCount: 7,
                //     WeakCount: 8
                //   }
                // ]})
              })
            }
          } else {
            this.$message.warning("请先生成中考分化数据");
          }
        })
      });
    },
    count() {
      this.getData();
    },
    export() {
      // if(this.data.length == 0) {
      //   this.$message.error("请先生成科任统计数据");
      //   return;
      // }
      let Ids = [];
      if(this.aid == this.eaid) {
        Ids = [this.aid]
      } else {
        Ids = [this.aid,this.eaid]
      }
      this.Entries.forEach(e => {
        Ids.push(e.AnalyseEntryId);
      })
      this.api.exportTeacher({
        Ids: Ids
      })
    },
    reset() {
      this.aid = "";
      this.eaid = "";
      this.names = {
        thisname: "",
        thisname2: "",
        enames: "",
      }
    }
  },
};
</script>
<style lang="scss">
</style>